import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import MemberDataService from '../../services/MemberDataService';
import '../../css/BisharatMain.css'
export default class ChildCreate extends Component {
    constructor() {
        super()
        this.state = {
            "parentId": '',
            "address": "",
            "birthdate": "",
            "fatherName": "",
            "gender": "",
            "identity": "",
            "isAlive": "",
            "isMarried": "",
            "motherName": "",
            "name": "",
            "phoneNumber": "",   
            errors: {},
            parent:{},
            successful: false,
            message: ""
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    componentDidMount() {
        this.refreshParent();
    }

    refreshParent = () => {
        const { match: { params } } = this.props;
        const id = params.id;
        MemberDataService.getMember(id)
            .then(res => {
                const parent = res.data;
                this.setState({parentId: parent.id });
                this.setState({parent: parent });
            })
    }


    createChild(childData) {
        MemberDataService.addChild(this.state.parentId,childData)         
              .then((response) => {
                this.setState({
                    message: response.data.message,
                    successful: true
                  });
                  alert("Member created Successfully !");

              },
            error => {
                const resMessage =
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString();
      
                this.setState({
                  successful: false,
                  message: resMessage
                });
              }
              );
            }
    
          onChange(event) {
            //that means that every event.target. name (the name in the elements) to assign the value to it. 
            this.setState({ [event.target.name]: event.target.value })
        }
    
        onSubmit(event) {
            event.preventDefault()

        
            const newChild = {
                address: this.state.address,
                birthdate: this.state.birthdate,
                gender: this.state.gender,
                identity: this.state.identity,
                isAlive: this.state.isAlive,
                isMarried: this.state.isMarried,
                motherName: this.state.motherName,
                name: this.state.name,
                phoneNumber: this.state.phoneNumber,
            };
           this.createChild(newChild);
        }
    


    render() {
        return (
            <div className="mainCreate">
                  <div className="top-container-forms childcreate">
                  <div className="create-form">
                  <h1>   اضافة طفل جديد   
                  </h1>
                    <form onSubmit={this.onSubmit}>
                                    <div className="form-group-create">
                                        <h5> الأسم </h5> 
                                        <input type="text"
                                            name="name" placeholder="Name"
                                            value={this.state.name}
                                            onChange={this.onChange}
                                        />
                                       
                                    </div>
                                    <div className="form-group-create">
                                    <h5> اسم الأم </h5> 
                                        <input type="text" className="form-control-form-cont" name="motherName" placeholder="Mother Name"
                                            value={this.state.motherName}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="form-group-create">
                                    <h5> رقم الهاتف </h5> 
                                        <input type="text" className="form-control-form-cont" name="phoneNumber" placeholder="Phone Number"
                                            value={this.state.phoneNumber}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="form-group-create">
                                    <h5> العنوان </h5> 
                                        <input type="text" className="form-control-form-cont" name="address" placeholder="Address"
                                            value={this.state.address}
                                            onChange={this.onChange}
                                        />
                                    </div>

                                    <div className="form-group-create">
                                    <h5> رقم الهويّة </h5> 
                                        <input type="text" className="form-control-form-cont" name="identity" placeholder="Identity"
                                            value={this.state.identity}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="form-group-create">
                                    <h5> تاريخ الميلاد </h5>
                                        <input type="text" className="form-control-form-cont" name="birthdate" placeholder="Birthdate"
                                            value={this.state.birthdate}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="form-group-create">
                                    <h5> الجنس </h5>
                                        <select className="form-control-form-cont" name="gender" onChange={this.onChange} >
                                            <option value="">الجنس؟  </option>
                                            <option value="Female">انثى</option>
                                            <option value="Male">ذكر</option>
                                      
                                        </select>
                                    </div>
                                    <div className="form-group-create">
                                    <h5> الحالة الاجتماعيّة </h5>
                                        <select className="form-control-form-cont" name="isMarried" onChange={this.onChange} >
                                            <option value="">الحالة الاجتماعيّة؟ </option>
                                            <option value="yes">متزوج</option>
                                            <option value="no">غير متزوج</option>
                                        </select>
                                    </div>
                                    <div className="form-group-create">
                                    <h5> على قيد الحياة؟</h5>
                                        <select className="form-control-form-cont" name="isAlive" onChange={this.onChange} >
                                            <option value="yes">is Alive ?</option>
                                            <option value="yes">Alive</option>
                                            <option value="no">Not Alive</option>
                                        </select>
                                    </div>
                             
                                    <input type="submit" value="ارسال" className="btn"/>
                                    


                                    {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  {this.state.message} 
                  
                </div>
            
              </div>
            )}




                                </form>
                                <button className="btn" onClick={this.props.history.goBack}> رجوع  </button>
                            </div>
                        </div>
                    </div>
              
        )
    }
}
